<template>
  <div>
    <b-form inline @submit.prevent.stop>
      <small class="text-muted mx-2">from</small>
      <b-form-datepicker size="sm" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
                         v-model="dateFrom" @input="updateValue"></b-form-datepicker>
      <small class="text-muted mx-2">to</small>
      <b-form-datepicker size="sm" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
                         v-model="dateTo" @input="updateValue"></b-form-datepicker>
    </b-form>

  </div>
</template>

<script>
import dayjs from "dayjs";

export default {
  name: "BqFilterDateRange",
  props: {
    value: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      dateFrom: dayjs().format(DATE_FORMAT),
      dateTo: dayjs().format(DATE_FORMAT)
    }
  },
  mounted() {
    if (this.value.length) {
      const val = [...this.value];
      this.dateFrom = val[0];
      this.dateTo = val[1];
    }
  },
  watch: {
    value: {
      deep: true,
      handler() {
        const val = [...this.value];
        this.dateFrom = val[0];
        this.dateTo = val[1];
      }
    }
  },
  methods: {
    updateValue() {
      this.$emit('input', [this.dateFrom, this.dateTo])
    }
  }
}
const DATE_FORMAT = 'YYYY-MM-DD';
</script>

<style scoped>

</style>